class FAQAccordion {
  constructor(container) {
    this.container = container;
    this.toggleButtons = container.querySelectorAll('[data-faq-toggle]');
    this.init();
  }

  init() {
    this.toggleButtons.forEach(button => {
      button.addEventListener('click', () => this.handleToggle(button));
    });
  }

  handleToggle(clickedButton) {
    const clickedItem = clickedButton.closest('.faq-item');
    const clickedContent = clickedItem.querySelector('[data-faq-content]');
    const isExpanded = clickedButton.getAttribute('aria-expanded') === 'true';

    // Close all other items
    this.toggleButtons.forEach(button => {
      if (button !== clickedButton) {
        const item = button.closest('.faq-item');
        const content = item.querySelector('[data-faq-content]');
        
        button.setAttribute('aria-expanded', 'false');
        content.setAttribute('hidden', '');
      }
    });

    // Toggle clicked item
    if (isExpanded) {
      clickedButton.setAttribute('aria-expanded', 'false');
      clickedContent.setAttribute('hidden', '');
    } else {
      clickedButton.setAttribute('aria-expanded', 'true');
      clickedContent.removeAttribute('hidden');
    }
  }
}

// Initialize all FAQ accordions on the page
document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('[data-faq-accordion]');
  accordions.forEach(accordion => new FAQAccordion(accordion));
});

// Support for Shopify theme editor
if (Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const accordion = event.target.querySelector('[data-faq-accordion]');
    if (accordion) {
      new FAQAccordion(accordion);
    }
  });
}
